import React from 'react';
import { InsightType } from '../../types/insights';
import './InsightsTabs.css';

interface InsightsTabsProps {
  activeTab: InsightType | 'all';
  onTabChange: (tab: InsightType | 'all') => void;
  opportunityCount: number;
  warningCount: number;
  patternCount: number;
  totalCount: number;
}

const InsightsTabs: React.FC<InsightsTabsProps> = ({
  activeTab,
  onTabChange,
  opportunityCount,
  warningCount,
  patternCount,
  totalCount,
}) => {
  const tabs: Array<{ id: InsightType | 'all'; label: string; count: number }> = [
    { id: 'all', label: 'All Insights', count: totalCount },
    { id: 'opportunity', label: 'Opportunities', count: opportunityCount },
    { id: 'warning', label: 'Warnings', count: warningCount },
    { id: 'pattern', label: 'Patterns', count: patternCount },
  ];

  return (
    <div 
      className="insights-tabs" 
      role="tablist" 
      aria-label="Filter insights by category"
    >
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`insights-tab ${activeTab === tab.id ? 'active' : ''}`}
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`insights-panel-${tab.id}`}
          onClick={() => onTabChange(tab.id)}
          type="button"
        >
          <span className="tab-label">{tab.label}</span>
          {tab.count > 0 && (
            <span className="tab-count" aria-label={`${tab.count} insights`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default InsightsTabs;
